import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'ai-marketing',
    title: 'AI Marketing',
    description: 'AI Marketing is a platform that helps businesses to create and manage their marketing campaigns.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        // url: 'https://ai-marketing.unrealos.com',
    },
};

export default data;
